import { render, staticRenderFns } from "./MailFolderSelect.vue?vue&type=template&id=4a998083"
import script from "./MailFolderSelect.vue?vue&type=script&lang=js"
export * from "./MailFolderSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports